import { graphql } from 'gatsby';
import React, { useState } from 'react';

import ComeAffittareCasa from '../components/ComeAffittareCasa';
import Seo from '../components/Seo';
import TextPageLandlord from '../components/TextPageLandlord';

const contentIndexItems = [
  {
    id: 'affitta-casa',
    text: `Affitta casa, appartamenti o stanze!`,
  },
  {
    id: 'pubblica-annuncio-gratis',
    text: 'Pubblica il tuo annuncio gratis',
  },
  {
    id: 'affittare-studenti-lavoratori',
    text: 'Affittare casa a studenti e lavoratori',
  },
  {
    id: 'affittare-online',
    text: 'Affittare online in tutta sicurezza',
  },
  {
    id: 'perche-scegliere-zappyrent',
    text: `Perché scegliere Zappyrent?`,
  },
  { id: 'faq', text: 'FAQ' },
];

const ComeAffittareCasaPage = (): JSX.Element => {
  const [contentIndexContextValue, setContentIndexContextValue] = useState([]);

  return (
    <>
      <Seo
        canonical="/it/come-affittare-casa"
        hreflang="it"
        title="Come Affittare Casa"
        description="Cerchi casa? Scopri come funziona il sito di affitti a lungo termine Zappyrent, segui tutti i passaggi e prendi in affitto l’alloggio che preferisci!"
        ogImageUrl={`${process.env.GATSBY_CDN_URL}/opengraph/zappyrent-logo-purple-500x500.png`}
        ogImageHeight="500"
        ogImageWidth="500"
      />
      <TextPageLandlord
        articleId="come-affittare-casa"
        h1Text={
          <>
            <span>Come affittare casa</span> su Zappyrent
          </>
        }
        h2Text={`Trova gli inquilini migliori e gestisci online i tuoi immobili
  con Zappyrent, una piattaforma smart pensata per innovare il
  sistema degli affitti immobiliari, mantenendo tutte le tutele
  per gli inquilini e le sicurezze per i proprietari.`}
        contentIndexContextValue={contentIndexContextValue}
        contentIndexItems={contentIndexItems}
      >
        <ComeAffittareCasa
          updateContext={value => setContentIndexContextValue(value.current)}
        />
      </TextPageLandlord>
    </>
  );
};

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;

export default ComeAffittareCasaPage;
